import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import RadioButton from '../RadioButton';
import Checkbox from '../Checkbox';
import styles from './CardSelect.module.scss';

const CardSelect = ({
  children,
  id,
  title,
  isSelected,
  name,
  value,
  onChange,
  type,
  disabled,
  labelText,
}) => {
  const InputComponent = useMemo(
    () => (type === 'radio' ? RadioButton : Checkbox),
    [type],
  );

  return (
    <div
      className={classnames(styles.wrapper, {
        [styles['is-selected']]: isSelected,
      })}
    >
      <InputComponent
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        isSelected={isSelected}
        checked={isSelected}
        disabled={disabled}
        label={(
          <div className={styles['content-wrapper']}>
            <div className={classnames('p3', 'medium', styles.title)}>
              {title}
            </div>
            <div>{children}</div>
          </div>
        )}
        labelText={labelText || title}
      />
    </div>
  );
};

CardSelect.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  labelText: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  isSelected: PropTypes.bool,
  type: PropTypes.oneOf(['radio', 'checkbox']),
  disabled: PropTypes.bool,
};

CardSelect.defaultProps = {
  id: '',
  isSelected: false,
  onChange: () => {},
  type: 'radio',
  value: '',
  disabled: false,
  labelText: '',
};

export default CardSelect;
